import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSelectorDown = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "M35.892 18.272H12.108L24 28.728z" }) }) })
});
export default SvgSelectorDown;
